export default {
    ok: '确定',
    okAndDelete: '确定并删除',
    cancel: '取消',
    workflowCenter: '流程中心',
    back: '返回',
    workflowTrack: '流程跟踪',
    personalInfo: '个人信息',
    switch: '切换',
    backStageManager: '后台管理',
    exitSys: '退出系统',
    noData: '暂无内容',
    errTips: '服务器开了个小差',
    goBack: '手动返回',
    closePage: '关闭当前页面',
    close: '关闭',
    changePwd: '修改密码',
    oldPwd: '原密码',
    oldPwdRequied: '原密码不能为空',
    newPwd: '新密码',
    newPwdRequied: '新密码不能为空',
    newPwdNotSame: '密码输入不一致',
    surePwd: '确认密码',
    changePwdSuccess: '修改密码成功！',
    helpCenter: '帮助中心',
    approval: '审批记录',
    userInfo: {
        name: '姓名',
        id: '用户名',
        departmentName: '所属部门',
        appellation: '职位',
        email: '邮箱',
        employeeNo: '工号',
        mobile: '手机号',
        officePhone: '办公电话',
        roleName: '角色',
        remark: '备注'
    },
    tip: {
        saveSuccess: '保存成功',
        operationFail: '操作失败，请重新尝试',
        paramsError: '参数错误',
        operationSucceed: '操作成功',
        operationFailed: '操作失败',
        sureToLogOut: '确定要退出当前登录？',
        confirm: '确定',
        cancel: '取消'
    },
};
